import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field } from 'redux-form';
import { fetchDropdown } from '../../../actions/actionCreators';
import { ITEM_NUMBER_TYPE } from '../../../constants/constant_doc_types';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class ItemNumberTypeDropdown extends Component {
  render() {
    const { name, form, fetchDropdown, multiple, preload = true } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          dropdownType={ITEM_NUMBER_TYPE}
          type={ITEM_NUMBER_TYPE}
          valueField="id"
          searchFn={fetchDropdown}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          preload={preload}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchDropdown,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(ItemNumberTypeDropdown);
